module.exports = __webpack_public_path__ + "static/telecom-vs-messengers-357018e32ad7dc9e36489c717faaf187.png";